import React from 'react';

import {TEditableColumn, TFieldStateType, ProgressCell} from 'components/editable-table';
import {IFieldMeta} from 'entities/metadata';
import {TEntity, TEntityValue} from 'modules/data';
import {TLookupValue} from 'modules/data/data-types';
import {ReactComponent as DeleteIcon} from 'shared/assets/close.svg';
import {createOptionItemsTransformer} from 'shared/utils';
import {IEntitySignatureUploadState} from 'store/slices/documents-uploading-slice';
import {IRegionDto} from 'store/slices/regions-slice';

const createStateCell = (activityList?: any) => (): TFieldStateType => activityList || {} as TFieldStateType;

type TOptionsType = {
    handleDelete: (tableRow: TEntity) => void;
    documentList?: TLookupValue[];
    progress?: {
        signUploadSlice: IEntitySignatureUploadState;
        fieldKey: string;
    };
};

export enum ESignatureUploadKeyCols {
    ACTIONS = 'actions',
    PROGRESS = 'progress',
    DOCUMENT_FILE_ID = 'documentFileId',
}

export const generateSignColumnsMetadata = (
    columnMeta: IFieldMeta,
    regions: IRegionDto[],
    {handleDelete, progress, documentList = []}: TOptionsType,
): TEditableColumn => {
    let columnSpecificProps: Record<string, any> = {};
    // eslint-disable-next-line default-case
    switch (columnMeta.key) {
    case ESignatureUploadKeyCols.PROGRESS:
        columnSpecificProps = {
            render: (_: any, record: Record<string, any>) => {
                const {fieldKey, signUploadSlice} = progress || {};
                const uniqueValue = record[fieldKey as string];
                const percent = signUploadSlice?.activityList?.[uniqueValue]?.uploadPercent ?? 0;
                const status = signUploadSlice?.activityList?.[uniqueValue]?.uploadStatus;

                return (
                    <ProgressCell
                        status={status}
                        percent={percent}
                    />
                );
            },
        };
        break;
    case ESignatureUploadKeyCols.DOCUMENT_FILE_ID:
        columnSpecificProps = {
            inputProps: {
                options: createOptionItemsTransformer(
                    'meaning', 'id', 'description',
                )(documentList),
            },
        };
        break;
    case ESignatureUploadKeyCols.ACTIONS:
        columnSpecificProps = {
            render: (_: any, record: Record<string, TEntityValue>) => (
                <DeleteIcon
                    style={{cursor: 'pointer', marginTop: 5}}
                    onClick={() => handleDelete(record)}
                />
            ),
        };
        break;
    }

    return {
        ...columnMeta,
        dataIndex: columnMeta.dataIndex || columnMeta.key,
        getFieldState: createStateCell({
            required: columnMeta?.required,
        }),
        inputProps: undefined,
        ...columnSpecificProps,
    };
};
